import React, { useState, useCallback, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Collapse,
  CircularProgress,
} from "@mui/material";
import animationData from "../../change.json";
import animationData3 from "./setting.json";
import {
  Logout,
  Brightness4,
  Brightness7,
  ExpandLess,
  ExpandMore,
  Home,
  SupervisedUserCircle,
  PostAddSharp,
  QuestionAnswerRounded,
  People,
  Work,
  MessageSharp,
  ContactPage,
  NoteAdd,
  Person,
} from "@mui/icons-material";
import { useAuth } from "./AuthContext";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import Lottie from "lottie-react";
import AllPost from "./PostManage/AllPosts";
import NewPost from "./PostManage/NewPost";
import AllMessages from "./Massages/AllMessages";
import Projects from "./ProjectManage/Projects";
import Project from "./ProjectManage/NewProject";
import NewFAQ from "./FAQ/NewFAQ";
import AllFAQ from "./FAQ/AllFAQ";
import NewUser from "./Users/NewUser";
import User from "./Users/User";
import Team from "./Team/Team";
import MYcv from "./Team/MYcv";
import NewMemeber from "./Team/NewMemeber";
import UserProfile from "./userprofile/UserProfile";

const Dashboard = ({ setmymode, mode }) => {
  const [currentView, setCurrentView] = useState("dashboard");
  const [openPosts, setOpenPosts] = useState(false);
  const [openUser, setOpenUser] = useState(false);
  const [openFAQ, setOpenFAQ] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openProjects, setOpenProjects] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const drawerWidth = "15rem";
  const { role, logout, token, uid } = useAuth();
  const [hasCV, setHasCV] = useState(null);
  useEffect(() => {
    const checkUserCV = async () => {
      try {
        const response = await fetch(
          "https://sirius.runasp.net/api/team/CheakCv",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              UserId: uid,
            }),
          }
        );

        if (response.ok) {
          const data = await response.json();
          setHasCV(data);
        } else {
          setHasCV(false);
        }
      } catch (error) {
        setHasCV(false);
      } finally {
        setLoading(false);
      }
    };

    checkUserCV();
  }, [token, uid]);
  const handleUserClick = useCallback(() => setOpenUser((prev) => !prev), []);
  const handlePostsClick = useCallback(() => setOpenPosts((prev) => !prev), []);
  const handleFAQClick = useCallback(() => setOpenFAQ((prev) => !prev), []);
  const handleProjectsClick = useCallback(
    () => setOpenProjects((prev) => !prev),
    []
  );
  const toggleDrawer = useCallback(() => setDrawerOpen((prev) => !prev), []);

  const renderContent = () => {
    switch (currentView) {
      case "newPost":
        return <NewPost />;
      case "allPosts":
        return <AllPost />;
      case "NewMemeber":
        return <NewMemeber />;
      case "Team":
        return <Team />;
      case "MYcv":
        return <MYcv />;
      case "newProject":
        return <Project />;
      case "NewUser":
        return <NewUser />;
      case "Users":
        return <User />;
      case "allProjects":
        return <Projects />;
      case "massages":
        return <AllMessages />;
      case "newFAQ":
        return <NewFAQ />;
      case "allFAQ":
        return <AllFAQ />;
      case "profile":
        return <UserProfile mode={mode} />;
      default:
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            <Typography variant="h3">
              <span style={{ color: "#e84545" }}>SIRIUS</span> Dashboard
            </Typography>
            <p>Please be careful about what you change ~~~</p>
            <Lottie
              style={{
                marginTop: "3rem",
                alignSelf: "center",
                width: "300px",
                height: "300px",
              }}
              animationData={animationData}
            />
          </div>
        );
    }
  };
  return (
    <Box sx={{ display: "flex", overflowX: "hidden" }}>
      <Box
        sx={{
          position: "absolute",
          top: 10,
          display: "flex",
          gap: "10px",
          width: "40px",
          height: "40px",
          left: 10,
        }}
      >
        <Link to="/admin" style={{ textDecoration: "none" }}>
          <button
            style={{
              cursor: "pointer",
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#e84545",
              padding: "5px",
              borderRadius: "40px",
              color: "#FFF",
              zIndex: "100",
            }}
            onClick={() => {
              logout(token);
            }}
          >
            <Logout sx={{ fontSize: "1.5rem" }} />
          </button>
        </Link>
        <Link to="/" style={{ textDecoration: "none" }}>
          <button
            style={{
              cursor: "pointer",
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#e84545",
              padding: "5px",
              borderRadius: "40px",
              zIndex: "100",
              color: "#FFF",
            }}
          >
            <Home sx={{ fontSize: "1.5rem" }} />
          </button>
        </Link>
      </Box>
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Box
          sx={{
            display: "flex",
            textAlign: "center",
            justifyContent: "flex-center",
            margin: "2rem 1rem 0 0",
            flexDirection: "column",
          }}
        >
          {renderContent()}
        </Box>
      </Box>
      <Box
        sx={{
          width: drawerOpen ? drawerWidth : "0rem",
          flexShrink: 0,
          position: {
            xs: "absolute", // On small screens, position it as absolute
            sm: "relative", // On larger screens, position it as relative
          },
          right: {
            xs: "-1rem", // Push to the right by 10rem on small screens
            sm: "0rem", // Reset the right alignment on larger screens
          },
          transition: "width 0.3s ease",
          marginRight: "2rem",
          background: {
            xs: "#333",
            sm: "none",
          },
          padding: drawerOpen ? " 5px 1rem" : "0rem",
          zIndex: "100",
          borderRadius: "2rem",
        }}
      >
        <Lottie
          style={{
            marginTop: ".5rem",
            width: "3.75rem",
            height: "3.75rem",
            position: "absolute",
            right: drawerOpen ? "15rem" : "0px",
            cursor: "pointer",
            transition: "right 0.3s ease",
          }}
          animationData={animationData3}
          onClick={toggleDrawer}
        />
        {drawerOpen && (
          <>
            <Box
              sx={{
                p: 2,
                textAlign: "center",
                padding: "1rem 4rem",
                background: "#800000",
                borderRadius: " 1.5rem",
                marginTop: "1.5rem",
              }}
            >
              <IconButton
                onClick={() => setmymode(mode === "light" ? "dark" : "light")}
                style={{ color: "#E85C0D" }}
              >
                {theme.palette.mode === "dark" ? (
                  <Brightness7 />
                ) : (
                  <Brightness4 />
                )}
              </IconButton>
              <Typography
                variant="h6"
                color="white"
                onClick={() => setCurrentView("dashboard")}
                sx={{ textAlign: "center", cursor: "pointer" }}
              >
                Dashboard
              </Typography>
              {/* <Lottie
                style={{
                  marginTop: "-1rem",
                  width: "16rem",
                  height: "3.125rem",
                  right: drawerOpen ? "16rem" : "0px",
                  cursor: "pointer",
                  transition: "right 0.3s ease",
                  pointerEvents: "none",
                }}
                animationData={animationData2}
                onClick={toggleDrawer}
              /> */}
            </Box>

            <List
              style={{
                background: "#800000",
                borderRadius: "2.5rem",
                padding: "1rem 1.5rem",
                marginTop: "2rem",
              }}
            >
              {role === "admin" && (
                <>
                  <Typography
                    variant="body1"
                    color="white"
                    sx={{ opacity: "80%", marginTop: ".5rem" }}
                  >
                    {" "}
                    Admin settings
                  </Typography>
                  <ListItem button onClick={handleUserClick}>
                    <SupervisedUserCircle
                      style={{ color: "#E85C0D", marginRight: ".5rem" }}
                    />{" "}
                    <ListItemText primary="Users " style={{ color: "#FFF" }} />
                    {openUser ? (
                      <ExpandLess style={{ color: "#FFF" }} />
                    ) : (
                      <ExpandMore style={{ color: "#FFF" }} />
                    )}
                  </ListItem>
                  <Collapse in={openUser} timeout="auto" unmountOnExit>
                    <List
                      component="div"
                      disablePadding
                      style={{ color: "#FFF" }}
                    >
                      <ListItemButton
                        onClick={() => setCurrentView("Users")}
                        sx={{ padding: "10px 5px 10px 4em" }}
                      >
                        Users
                      </ListItemButton>
                      <ListItemButton
                        onClick={() => setCurrentView("NewUser")}
                        sx={{ padding: "10px 5px 10px 4em" }}
                      >
                        New User
                      </ListItemButton>
                    </List>
                  </Collapse>
                  <>
                    <ListItem button onClick={handleFAQClick}>
                      <QuestionAnswerRounded
                        style={{ color: "#E85C0D", marginRight: ".5rem" }}
                      />{" "}
                      <ListItemText primary="FAQ" style={{ color: "#FFF" }} />
                      {openFAQ ? (
                        <ExpandLess style={{ color: "#FFF" }} />
                      ) : (
                        <ExpandMore style={{ color: "#FFF" }} />
                      )}
                    </ListItem>
                    <Collapse in={openFAQ} timeout="auto" unmountOnExit>
                      <List
                        component="div"
                        disablePadding
                        style={{ color: "#FFF" }}
                      >
                        <ListItemButton
                          onClick={() => setCurrentView("newFAQ")}
                          sx={{ padding: "10px 5px 10px 4em" }}
                        >
                          New FAQ
                        </ListItemButton>
                        <ListItemButton
                          onClick={() => setCurrentView("allFAQ")}
                          sx={{ padding: "10px 5px 10px 4em" }}
                        >
                          All FAQ
                        </ListItemButton>
                      </List>
                    </Collapse>
                  </>
                  <ListItem button onClick={() => setCurrentView("Team")}>
                    <People
                      style={{ color: "#E85C0D", marginRight: ".5rem" }}
                    />{" "}
                    <ListItemText
                      primary="All members"
                      style={{ color: "#FFF" }}
                    />
                  </ListItem>
                </>
              )}
              <Typography
                variant="body1"
                color="white"
                sx={{ opacity: "80%", marginTop: ".5rem" }}
              >
                {" "}
                Member settings
              </Typography>
              <ListItem button onClick={handlePostsClick}>
                <PostAddSharp
                  style={{ color: "#E85C0D", marginRight: ".5rem" }}
                />{" "}
                <ListItemText primary="Posts" style={{ color: "#FFF" }} />
                {openPosts ? (
                  <ExpandLess style={{ color: "#FFF" }} />
                ) : (
                  <ExpandMore style={{ color: "#FFF" }} />
                )}
              </ListItem>
              <Collapse in={openPosts} timeout="auto" unmountOnExit>
                <List component="div" disablePadding style={{ color: "#FFF" }}>
                  <ListItemButton
                    onClick={() => setCurrentView("newPost")}
                    sx={{ padding: "10px 5px 10px 4em" }}
                  >
                    New Post
                  </ListItemButton>
                  <ListItemButton
                    onClick={() => setCurrentView("allPosts")}
                    sx={{ padding: "10px 5px 10px 4em" }}
                  >
                    All Posts
                  </ListItemButton>
                </List>
              </Collapse>
              <ListItem button onClick={handleProjectsClick}>
                <Work style={{ color: "#E85C0D", marginRight: ".5rem" }} />{" "}
                <ListItemText primary="Projects" style={{ color: "#FFF" }} />
                {openProjects ? (
                  <ExpandLess style={{ color: "#FFF" }} />
                ) : (
                  <ExpandMore style={{ color: "#FFF" }} />
                )}
              </ListItem>
              <Collapse in={openProjects} timeout="auto" unmountOnExit>
                <List component="div" disablePadding style={{ color: "#FFF" }}>
                  <ListItemButton
                    onClick={() => setCurrentView("newProject")}
                    sx={{ padding: "10px 5px 10px 4em" }}
                  >
                    New Project
                  </ListItemButton>
                  <ListItemButton
                    onClick={() => setCurrentView("allProjects")}
                    sx={{ padding: "10px 5px 10px 4em" }}
                  >
                    All Projects
                  </ListItemButton>
                </List>
              </Collapse>
              <ListItem button onClick={() => setCurrentView("massages")}>
                <MessageSharp
                  style={{ color: "#E85C0D", marginRight: ".5rem" }}
                />{" "}
                <ListItemText primary="Messages" style={{ color: "#FFF" }} />
              </ListItem>
              <Typography
                variant="body1"
                color="white"
                sx={{ opacity: "80%", marginTop: ".5rem" }}
              >
                {" "}
                Account settings
              </Typography>
              {loading ? (
                <CircularProgress
                  style={{
                    color: "#E85C0D",
                    width: "1rem",
                    height: "1rem",
                    margin: "0 auto",
                  }}
                />
              ) : hasCV ? (
                <ListItem button onClick={() => setCurrentView("MYcv")}>
                  <ContactPage
                    style={{ color: "#E85C0D", marginRight: ".5rem" }}
                  />{" "}
                  <ListItemText primary="MYcv" style={{ color: "#FFF" }} />
                </ListItem>
              ) : (
                <ListItem button onClick={() => setCurrentView("NewMemeber")}>
                  <NoteAdd style={{ color: "#E85C0D", marginRight: ".5rem" }} />{" "}
                  <ListItemText
                    primary="NewMemeber"
                    style={{ color: "#FFF" }}
                  />
                </ListItem>
              )}

              <ListItem button onClick={() => setCurrentView("profile")}>
                <Person style={{ color: "#E85C0D", marginRight: ".5rem" }} />{" "}
                <ListItemText primary="Profile" style={{ color: "#FFF" }} />
              </ListItem>
            </List>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Dashboard;
